export default {
      id: "ic_fast_deposit_cancel_error-usage",
      viewBox: "0 0 56 56",
      url: "/" + "images/icons.3.109.2.svg#ic_fast_deposit_cancel_error-usage",
      toString: function () {
        return this.url;
      }
    }